'use client';

const NOVA_CDN_STATIC_ASSET_PREFIX = /https:\/\/fe-cdn\.newfront\.com\/nova-app\/[^/]+\/_next\/static\//g;
const ENCODED_NOVA_CDN_STATIC_ASSET_PREFIX =
  /https%3A%2F%2Ffe-cdn\.newfront\.com%2Fnova-app%2F[^%]+%2F_next%2Fstatic%2F/g;
const SAME_ORIGIN_STATIC_ASSET_PATH = '/chat/_next/static/';

type WorkerPatchState = {
  nativeWorker?: typeof Worker;
  patchedWorker?: typeof Worker;
  referenceCount: number;
};

const workerPatchState: WorkerPatchState = {
  referenceCount: 0,
};

function getSameOriginStaticAssetPrefix(origin: string) {
  return new URL(SAME_ORIGIN_STATIC_ASSET_PATH, origin).toString();
}

export function rewriteNovaWorkerAssetUrl(scriptUrl: string | URL, origin: string) {
  const scriptUrlString = scriptUrl.toString();

  if (!scriptUrlString.includes('fe-cdn.newfront.com/nova-app/')) {
    return scriptUrl;
  }

  const sameOriginStaticAssetPrefix = getSameOriginStaticAssetPrefix(origin);
  const rewrittenUrl = scriptUrlString
    .replace(NOVA_CDN_STATIC_ASSET_PREFIX, sameOriginStaticAssetPrefix)
    .replace(ENCODED_NOVA_CDN_STATIC_ASSET_PREFIX, encodeURIComponent(sameOriginStaticAssetPrefix));

  return scriptUrl instanceof URL ? new URL(rewrittenUrl) : rewrittenUrl;
}

export function installSameOriginXlsxWorkerAssets() {
  if (typeof window === 'undefined' || typeof window.Worker === 'undefined') {
    return () => undefined;
  }

  if (workerPatchState.referenceCount === 0) {
    const NativeWorker = window.Worker;
    const PatchedWorker = function createWorker(scriptUrl: string | URL, options?: WorkerOptions) {
      return new NativeWorker(rewriteNovaWorkerAssetUrl(scriptUrl, window.location.origin), options);
    } as unknown as typeof Worker;

    PatchedWorker.prototype = NativeWorker.prototype;
    workerPatchState.nativeWorker = NativeWorker;
    workerPatchState.patchedWorker = PatchedWorker;
    window.Worker = PatchedWorker;
  }

  workerPatchState.referenceCount += 1;

  return () => {
    workerPatchState.referenceCount = Math.max(0, workerPatchState.referenceCount - 1);

    if (
      workerPatchState.referenceCount === 0 &&
      workerPatchState.patchedWorker &&
      window.Worker === workerPatchState.patchedWorker
    ) {
      window.Worker = workerPatchState.nativeWorker ?? window.Worker;
      workerPatchState.nativeWorker = undefined;
      workerPatchState.patchedWorker = undefined;
    }
  };
}
